import React, { useCallback, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useOnSelectionChange } from '@xyflow/react'
import SydButton from '../../../commonDesign/Button'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { NodeDetails } from './NodeDetails'

const useStyles = makeStyles({
  toggleButton: {
    position: 'absolute',
    top: 'var(--padding-md)',
    right: 'var(--padding-md)',
    zIndex: 103,
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out'
  },
  title: {
    fontSize: 'var(--font-size-lg)',
    margin: '0 70px 16px 0'
  },
  innerContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '500px',
    background: 'color-mix(in srgb, var(--theme-color-surface-d0) 70%, transparent)',
    borderRight: 'var(--border-primary-thin)',
    padding: 'var(--padding-md)',
    boxShadow: 'var(--shadow-md)',
    backdropFilter: 'blur(10px)',
    zIndex: 101,
    transform: 'translate(-100%, 0)',
    transition: 'transform 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '&.open': {
      transform: 'translate(0, 0)'
    }
  }
})

export const DetailsSidebar = () => {
  const classes = useStyles()
  const { state: { detailsItem, data }, dispatch } = useEntityGraphContext()

  const onChange = useCallback(({ nodes, edges }) => {
    if (nodes?.length === 1 && !!detailsItem) {
      return dispatch({
        type: 'TOGGLE_EDIT_SIDEBAR',
        payload: {
          path: 'detailsItem',
          value: {
            id: nodes[0].id,
            type: 'node'
          }
        }
      })
    }
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'detailsItem', value: null } })
  }, [dispatch, detailsItem])

  useOnSelectionChange({
    onChange
  })

  const onClose = useCallback(() => {
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'detailsItem', value: null } })
  }, [dispatch])

  const selectedItem = useMemo(() => {
    if (detailsItem?.type === 'node') {
      return data?.nodes?.find(node => node.id === detailsItem?.id)
    }
    return null
  }, [data, detailsItem])

  return (
    <div className={classes.container}>
      <div className={clsx(classes.innerContainer, { open: !!detailsItem })}>
        <SydButton
          className={clsx(classes.toggleButton, { open: !!detailsItem })}
          onClick={onClose}
        >
          <Icon name={ICON_NAMES.close} size='md' />
        </SydButton>
        <h2 className={classes.title}>{selectedItem?.data?.label ?? 'Details'}</h2>
        {detailsItem?.type === 'node' && (
          <>
            <NodeDetails nodeId={detailsItem?.id} />
          </>
        )}
      </div>
    </div>
  )
}
